/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userTransactionHistory

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userTransactionHistory.internal.UserTransactionHistoryUseCase
import features.userTransactionHistory.internal.UserTransactionHistoryUseCase.Params
import features.userTransactionHistory.models.UserTransactionHistoryModel


typealias UserTransactionHistoryState = CFlow<UserTransactionHistoryUseCaseResult?>

typealias UserTransactionHistoryUseCaseResult = Result<UserTransactionHistoryModel>

fun UserTransactionHistoryUseCaseResult.serializeUserTransactionHistoryApiResult(): SerializedResult<String> {
    return this.toJsonResult<UserTransactionHistoryModel>()
}

/**
 * Serializes [UserTransactionHistoryState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserTransactionHistoryState.serializeUserTransactionHistoryState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<UserTransactionHistoryModel>()
    }.asCFlow()
}

/**
 * Get transaction history this user. [Api] class
 */
class UserTransactionHistoryApi : Api() {

    val userTransactionHistoryState: UserTransactionHistoryState
        get() = _userTransactionHistoryState.asCFlow()

    companion object {
        private val _userTransactionHistoryState: MutableStateFlow<UserTransactionHistoryUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userTransactionHistoryUseCase = UserTransactionHistoryUseCase()

    /**
     * Get transaction history this user.
     */
    suspend fun getUserTransactionHistory(
        overrideHeaders: Map<String, String>? = null,

    ): Result<UserTransactionHistoryModel> {
        /* set state to Loading as soon as function is called */
        _userTransactionHistoryState.value = Loading()
        val result = this.userTransactionHistoryUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _userTransactionHistoryState.value = result
            return@userTransactionHistoryUseCase result
        }
        return result
    }

}
